import * as React from "react";
import { InternalWorkloadItems } from "./internalWorkloadItems";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";
import { useGetWorkloadQuery } from "../../../../store/api/workloadApi";
import { CopyButtonWithApproval } from "../../../domain/create/copyButtonWithApproval";

interface Props {}
export const Internal: React.FC<Props> = ({}) => {
  const type = useCpFormValue(`firewallConfig.internal.type`);
  const isCreate = useCpFormValue(`meta.isCreate`);
  const workloadLink = useCpFormValue(`meta.workloadLink`);
  const { data: workload } = useGetWorkloadQuery(workloadLink, { skip: !workloadLink || isCreate });
  const internalName = !isCreate ? workload?.status?.internalName : undefined;

  return (
    <>
      {internalName && (
        <div className="flex items-center gap-2 mb-4" style={{ fontFamily: "var(--font-family-code)", fontSize: 13 }}>
          <span style={{ color: "var(--color-label)" }}>Internal Hostname:</span>
          <span>{internalName}</span>
          <CopyButtonWithApproval value={internalName} />
        </div>
      )}
      <CpFormItem>
        <CpLabel name={`firewallConfig.internal.type`}>
          Inbound Allow Type
          <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
            <CpLabelDirtyIndicator name={`firewallConfig.internal.type`} />
          </Only>
        </CpLabel>
        <CpSelect
          name={`firewallConfig.internal.type`}
          options={[
            { label: "None", value: "none" },
            { label: "Same GVC", value: "same-gvc" },
            { label: "Same ORG", value: "same-org" },
            { label: "Workload List", value: "workload-list" },
            { label: "Same GVC & Workload List", value: "same-gvc-and-workload-list" },
          ]}
          style={{ width: 400 }}
        />
      </CpFormItem>
      {!type.includes(`workload-list`) ? null : <InternalWorkloadItems />}
    </>
  );
};
